<div class="manage-recipient">
  <np-add-beneficiary-step></np-add-beneficiary-step>

  <div class="col-md-10 offset-md-1">
    <div class="receipient-header">
      <strong *ngIf="action !== addRecipientFrom.Bank">Add new beneficiary |</strong>
      <strong *ngIf="action === addRecipientFrom.Bank">Bank Account Details |</strong> Payment details
    </div>
  </div>

  <form [formGroup]="formStep2" class="add-recipient">

    <div class="col-sm-12 col-md-4 offset-md-4">
      <ng-container *ngIf="isIBANRequired">
        <div class="row form-group">
          <mat-form-field [ngClass]="{
                'is-valid': formStep2.get('iban').valid && formStep2.get('iban').touched,
                'is-invalid': !formStep2.get('iban').valid && formStep2.get('iban').touched
              }">
            <input matInput placeholder="IBAN number" formControlName="iban" class="no-upscope"/>
          </mat-form-field>
          <div class="error-message" *ngIf="formStep2.get('iban').hasError('required') && formStep2.get('iban').touched">
            Please input information here
          </div>
          <div class="error-message" *ngIf="(
                formStep2.get('iban').hasError('maxlength') ||
                formStep2.get('iban').hasError('minlength') ||
                formStep2.get('iban').hasError('pattern')
                ) && formStep2.get('iban').touched">
            IBAN code must between 15 and 34 characters and must contains both letters and numbers or only contain letter.
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isFasterPayandGBP">
        <div class="row form-group">
          <mat-form-field [ngClass]="{
              'is-valid': formStep2.get('accountNumber').valid && !formStep2.hasError('bankDetailsError') && formStep2.get('accountNumber').touched,
              'is-invalid': (!formStep2.get('accountNumber').valid && formStep2.get('accountNumber').touched) ||
               (!formStep2.get('accountNumber').value && formStep2.get('sortCode').value && !formStep2.get('iban').value
               && formStep2.get('accountNumber').touched && formStep2.get('sortCode').touched) ||
               (formStep2.hasError('bankDetailsError') && formStep2.get('accountNumber').touched && formStep2.get('sortCode').touched && formStep2.get('iban').touched)
            }">
            <input matInput placeholder="Account number" formControlName="accountNumber" class="no-upscope"/>
          </mat-form-field>
          <div class="error-message" *ngIf="formStep2.get('accountNumber').hasError('pattern') && formStep2.get('accountNumber').touched">
            Account number must be 8 numbers.
          </div>
        </div>

        <div class="row form-group">
          <mat-form-field [ngClass]="{
              'is-valid': formStep2.get('sortCode').valid && !formStep2.hasError('bankDetailsError') && formStep2.get('sortCode').touched,
              'is-invalid': (!formStep2.get('sortCode').valid && formStep2.get('sortCode').touched) ||
               (!formStep2.get('sortCode').value && formStep2.get('accountNumber').value && !formStep2.get('iban').value
               && formStep2.get('accountNumber').touched && formStep2.get('sortCode').touched) ||
               (formStep2.hasError('bankDetailsError') && formStep2.get('accountNumber').touched && formStep2.get('sortCode').touched && formStep2.get('iban').touched)
            }">
            <input matInput placeholder="Sort code" formControlName="sortCode" npInputMask [options]="{
                delimiter: '-',
                blocks: [2, 2, 2]
              }" (keypress)="$event.charCode >= 48 && $event.charCode <= 57" class="no-upscope"/>
          </mat-form-field>
          <div class="error-message" *ngIf="formStep2.get('sortCode').hasError('pattern') && formStep2.get('sortCode').touched">
            Sort code must be 6 characters and contain only numeric
          </div>
        </div>

        <div class="row form-group">
          or
        </div>

        <div class="row form-group">
          <mat-form-field [ngClass]="{
                        'is-valid': formStep2.get('iban').valid && formStep2.get('iban').touched,
                        'is-invalid': (!formStep2.get('iban').valid || formStep2.hasError('bankDetailsError')) && formStep2.get('iban').touched
                      }">
            <input matInput placeholder="IBAN number" formControlName="iban" class="no-upscope" />
          </mat-form-field>
          <div class="error-message" *ngIf="(
                        formStep2.get('iban').hasError('maxlength') ||
                        formStep2.get('iban').hasError('minlength') ||
                        formStep2.get('iban').hasError('pattern')
                        ) && formStep2.get('iban').touched">
            IBAN code must between 15 and 34 characters and must contains both letters and numbers or only contain letter.
          </div>
          <div class="error-message" *ngIf="formStep2.hasError('bankDetailsError')
              && formStep2.get('sortCode').touched
              && formStep2.get('accountNumber').touched
              && formStep2.get('iban').touched">
            Please input Account Number and Sort Code or IBAN
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isBankCodeAndAccountMandatory">
        <div class="row form-group">
          <mat-form-field [ngClass]="{
                  'is-valid': formStep2.get('accountNumber').valid && formStep2.get('accountNumber').value && formStep2.get('accountNumber').touched,
                  'is-invalid': (!formStep2.get('accountNumber').valid || !formStep2.get('accountNumber').value) && formStep2.get('accountNumber').touched
                }">
            <input matInput placeholder="Account number" formControlName="accountNumber" class="no-upscope"/>
          </mat-form-field>
          <div class="error-message" *ngIf="!formStep2.get('accountNumber').value && formStep2.get('accountNumber').touched">
            Please input information here
          </div>
          <div class="error-message" *ngIf="formStep2.get('accountNumber').hasError('pattern') && formStep2.get('accountNumber').touched">
            <ng-container *ngIf="isFasterPay">
              Account number must be 8 numbers.
            </ng-container>
            <ng-container *ngIf="!isFasterPay">
              Account number is required and can only include characters and numbers.
            </ng-container>
          </div>
        </div>

        <div class="row form-group">
          <mat-form-field [ngClass]="{
                  'is-valid': formStep2.get('bankCode').valid && formStep2.get('bankCode').value && formStep2.get('bankCode').touched,
                  'is-invalid': (!formStep2.get('bankCode').valid || !formStep2.get('bankCode').value) && formStep2.get('bankCode').touched
                      }">
            <input matInput placeholder="Bank code" formControlName="bankCode" class="no-upscope"/>
          </mat-form-field>
          <div class="error-message" *ngIf="
                !formStep2.get('bankCode').value &&
                formStep2.get('bankCode').touched
              ">
            Please input information here
          </div>

          <div class="error-message" *ngIf="
                    formStep2.get('bankCode').hasError('pattern') &&
                    !isBankCode9Digits &&
                    formStep2.get('bankCode').touched
                  ">
            Bank code must be number and characters, no special characters
          </div>
          <div class="error-message" *ngIf="
                              formStep2.get('bankCode').hasError('pattern') &&
                              isBankCode9Digits &&
                              formStep2.get('bankCode').touched
                            ">
            Bank code must be 9 digits
          </div>
        </div>
      </ng-container>


      <ng-container *ngIf="!isFasterPayandGBP && !isIBANRequired && !isBankCodeAndAccountMandatory">
        <div class="row form-group">
          <mat-form-field [ngClass]="{
                          'is-valid': formStep2.get('accountNumber').valid && formStep2.get('accountNumber').value && formStep2.get('accountNumber').touched,
                          'is-invalid': (!formStep2.get('accountNumber').valid || !formStep2.get('accountNumber').value) && formStep2.get('accountNumber').touched
                        }">
            <input matInput placeholder="Account number" formControlName="accountNumber" class="no-upscope" />
          </mat-form-field>
          <div class="error-message" *ngIf="!formStep2.get('accountNumber').value && formStep2.get('accountNumber').touched">
            Please input information here
          </div>
          <div class="error-message"
            *ngIf="formStep2.get('accountNumber').hasError('pattern') && formStep2.get('accountNumber').touched">
            <ng-container *ngIf="isFasterPay">
              Account number must be 8 numbers.
            </ng-container>
            <ng-container *ngIf="!isFasterPay">
              Account number is required and can only include characters and numbers.
            </ng-container>
          </div>
        </div>

        <div class="row form-group justify-content-between align-items-center">
          <div class="col-5 px-0">
            <mat-form-field [ngClass]="{
                          'is-valid': formStep2.get('bankCode').valid && (formStep2.get('bankCode').value  || formStep2.get('swiftCode').value) && formStep2.get('bankCode').touched && formStep2.get('swiftCode').touched,
                          'is-invalid': !formStep2.get('bankCode').valid || (!formStep2.get('bankCode').value && !formStep2.get('swiftCode').value) && formStep2.get('bankCode').touched && formStep2.get('swiftCode').touched
                              }">
              <input matInput placeholder="Bank code" formControlName="bankCode" class="no-upscope" />
            </mat-form-field>
          </div>
          <div>or</div>
          <div class="col-5 px-0">
            <mat-form-field [ngClass]="{
                          'is-valid': formStep2.get('swiftCode').valid && (formStep2.get('bankCode').value  || formStep2.get('swiftCode').value) && formStep2.get('bankCode').touched && formStep2.get('swiftCode').touched,
                          'is-invalid': !formStep2.get('swiftCode').valid || formStep2.hasError('swiftCodeError') || (!formStep2.get('bankCode').value && !formStep2.get('swiftCode').value) && formStep2.get('bankCode').touched && formStep2.get('swiftCode').touched
                              }">
              <input matInput placeholder="SWIFT code" formControlName="swiftCode" />
            </mat-form-field>
          </div>
          <div class="error-message"
            *ngIf="!formStep2.get('swiftCode').value && formStep2.get('swiftCode').touched && !formStep2.get('bankCode').value && formStep2.get('bankCode').touched">
            Please input bank code or SWIFT code
          </div>
          <div class="error-message" *ngIf="
                                                  (formStep2.hasError('swiftCodeError') ||
                                                  formStep2.get('swiftCode').hasError('pattern')) &&
                                                  formStep2.get('swiftCode').touched
                                                ">
            SWIFT code must be 8 or 11 letters. SWIFT code must contain both number and letter or only contain letter
          </div>
          <div class="error-message" *ngIf="
                            formStep2.get('bankCode').hasError('pattern') &&
                            formStep2.get('bankCode').touched
                          ">
            Bank code must be number and characters, no special characters
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf= "!validationOk">
        <div class="row col-6 px-0">
          <button class="btn btn-lg btn-block" [ngClass]="{
            'btn-greengo': formStep2.valid,
            'btn-inactive': !formStep2.valid
          }" (click)="validate()" npFocusOutClicked>Continue</button>
        </div>
        <div class="row">
          <p class="mt-3">Once the information entered has been validated successfully, beneficiaries bank details will be automatically filled below.</p>
        </div>
      </ng-container>
    </div>
  </form>

  <form [formGroup]="formStep3" class="add-recipient">

    <div class="col-md-10 offset-md-1">
      <div class="receipient-header">
        <strong *ngIf="action !== addRecipientFrom.Bank">Add new beneficiary |</strong>
        <strong *ngIf="action === addRecipientFrom.Bank">Bank Account Details |</strong> Bank Details
      </div>
    </div>

    <div class="col-sm-12 col-md-4 offset-md-4">
      <div class="row form-group">
        <mat-form-field [ngClass]="{
          'is-valid': formStep3.get('bankName').valid && formStep3.get('bankName').touched,
          'is-invalid': !formStep3.get('bankName').valid && formStep3.get('bankName').touched
        }">
          <input matInput placeholder="Bank Name" formControlName="bankName" readonly>
        </mat-form-field>
        <div class="error-message" *ngIf="formStep3.get('bankName').hasError('required') && formStep3.get('bankName').touched">
          Please input information here
        </div>
        <div class="error-message" *ngIf="formStep3.get('bankName').hasError('maxlength') && formStep3.get('bankName').touched">
          Maximum of 100 characters
        </div>
      </div>

      <div class="row form-group">
        <mat-form-field [ngClass]="{
          'is-valid': formStep3.get('address1').valid && formStep3.get('address1').touched,
          'is-invalid': !formStep3.get('address1').valid && formStep3.get('address1').touched
        }">
          <input matInput placeholder="Address line 1" formControlName="address1" readonly>
        </mat-form-field>
        <div class="error-message" *ngIf="formStep3.get('address1').hasError('required') && formStep3.get('address1').touched">
          Please input information here
        </div>
        <div class="error-message" *ngIf="formStep3.get('address1').hasError('maxlength') && formStep3.get('address1').touched">
          Maximum of 255 characters
        </div>
      </div>

      <div class="row form-group">
        <mat-form-field [ngClass]="{
          'is-valid': formStep3.get('address2').valid && formStep3.get('address2').touched,
          'is-invalid': !formStep3.get('address2').valid && formStep3.get('address2').touched
        }">
          <input matInput placeholder="Address line 2" formControlName="address2" readonly>
        </mat-form-field>
        <div class="error-message" *ngIf="formStep3.get('address2').hasError('maxlength') && formStep3.get('address2').touched">
          Maximum of 255 characters
        </div>
      </div>

      <div class="row form-group">
        <mat-form-field [ngClass]="{
          'is-valid': formStep3.get('address3').valid && formStep3.get('address3').touched,
          'is-invalid': !formStep3.get('address3').valid && formStep3.get('address3').touched
        }">
          <input matInput placeholder="Address line 3" formControlName="address3" readonly>
        </mat-form-field>
        <div class="error-message" *ngIf="formStep3.get('address3').hasError('maxlength') && formStep3.get('address3').touched">
          Maximum of 255 characters
        </div>
      </div>

      <div class="row form-group">
        <mat-form-field [ngClass]="{
          'is-valid': formStep3.get('city').valid && formStep3.get('city').touched,
          'is-invalid': !formStep3.get('city').valid && formStep3.get('city').touched
        }">
          <input matInput placeholder="City" formControlName="city" readonly>
        </mat-form-field>
        <div class="error-message" *ngIf="formStep3.get('city').hasError('required') && formStep3.get('city').touched">
          Please input information here
        </div>
        <div class="error-message" *ngIf="formStep3.get('city').hasError('maxlength') && formStep3.get('city').touched">
          Maximum of 50 characters
        </div>
      </div>

      <div class="row form-group">
        <mat-form-field [ngClass]="{
          'is-valid': formStep3.get('stateProvince').valid && formStep3.get('stateProvince').touched,
          'is-invalid': !formStep3.get('stateProvince').valid && formStep3.get('stateProvince').touched
        }">
          <input matInput placeholder="State/Province" formControlName="stateProvince" readonly>
        </mat-form-field>
        <div class="error-message" *ngIf="formStep3.get('stateProvince').hasError('maxlength') && formStep3.get('stateProvince').touched">
          Maximum of 100 characters
        </div>
      </div>

      <div class="row form-group">
        <mat-form-field [ngClass]="{
          'is-valid': formStep3.get('zipPostalCode').valid && formStep3.get('zipPostalCode').touched,
          'is-invalid': !formStep3.get('zipPostalCode').valid && formStep3.get('zipPostalCode').touched
        }">
          <input matInput placeholder="Zip code/Postal code" formControlName="zipPostalCode" readonly>
        </mat-form-field>
        <div class="error-message" *ngIf="formStep3.get('zipPostalCode').hasError('maxlength') && formStep3.get('zipPostalCode').touched">
          Maximum of 20 characters
        </div>
      </div>

      <div class="row form-group">
        <mat-form-field>
          <mat-select placeholder="Country" formControlName="country" disabled>
            <mat-select-trigger>
              <ng-container *ngIf="!formStep3.get('country').value; else showCountry">
                -----
              </ng-container>
              <ng-template #showCountry>
                <div [innerHTML]="formStep3.get('country').value | transformCountry : countries"></div>
              </ng-template>
            </mat-select-trigger>
            <mat-option *ngFor="let country of countries" [value]="country.id">
              <span [class]="country.code | flagIcon"></span>&nbsp;
              <span>{{country.name}}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row form-group">
        <mat-form-field [ngClass]="{
          'is-valid': formStep3.get('reference').valid && formStep3.get('reference').touched,
          'is-invalid': !formStep3.get('reference').valid && formStep3.get('reference').touched
        }">
          <input matInput placeholder="Reference (Optional)" formControlName="reference" maxlength="70">
        </mat-form-field>
        <div class="error-message" *ngIf="formStep3.get('reference').hasError('maxlength') && formStep3.get('reference').touched">
          Maximum of 70 characters
        </div>
        <div class="error-message" *ngIf="formStep3.get('reference').hasError('pattern') && formStep3.get('reference').touched">
          <np-swift-character-message></np-swift-character-message>
        </div>
      </div>

      <div class="row form-group">
        <mat-form-field [ngClass]="{
          'is-valid': formStep3.get('bankAccountType').valid && formStep3.get('bankAccountType').touched,
          'is-invalid': !formStep3.get('bankAccountType').valid && formStep3.get('bankAccountType').touched
        }">
          <mat-select placeholder="Bank Account Type" formControlName="bankAccountType">
            <mat-option [value]="null">None</mat-option>
            <mat-option *ngFor="let item of bankAccountTypes" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="error-message"
          *ngIf="!formStep3.get('bankAccountType').valid && formStep3.get('bankAccountType').touched">
          Please input information here
        </div>
      </div>

      <ng-container *ngIf="action !== addRecipientFrom.Bank">

        <ng-container *ngIf="this.purposeOfPayments.length > 0">
          <div class="row form-group">
            <mat-form-field [ngClass]="{'is-valid': purposeOfPaymentSelected && formStep3.get('purposeOfPayment').valid && formStep3.get('purposeOfPayment').touched,
                                            'is-invalid': (!purposeOfPaymentSelected || !formStep3.get('purposeOfPayment').valid) && formStep3.get('purposeOfPayment').touched}"
              matTooltip="{{ purposeOfPaymentSelected ? formStep3.get('purposeOfPayment').value : null}}" [matTooltipPosition]="'left'"
              matTooltipClass="custom-mat-tooltip">
              <input type="text" formControlName="purposeOfPayment" matInput [matAutocomplete]="auto" placeholder="Purpose of payment">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPurposeOfPayment($event)">
                <mat-option *ngFor="let pp of purposeOfPaymentsPipe | async" [value]="pp" matTooltip="{{ pp.code }} - {{ pp.description }}"
                  matTooltipClass="custom-mat-tooltip" [matTooltipPosition]="'below'">
                  {{ pp.code }} - {{ pp.description }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div class="error-message" *ngIf="formStep3.get('purposeOfPayment').hasError('required') && formStep3.get('purposeOfPayment').touched">
              Please input information here
            </div>
            <div class="error-message" *ngIf="formStep3.get('purposeOfPayment').value && !purposeOfPaymentSelected && formStep3.get('purposeOfPayment').touched">
              Please input valid information here
            </div>
          </div>
        </ng-container>

        <div class="row form-group" *ngIf="action !== addRecipientFrom.ManageRecipient">
          <mat-checkbox disableRipple class="greengo circle-checkbox" [checked]="saveForFuture" (change)="saveForFuture = !saveForFuture; saveForFutureMandate($event)">Save for future payments</mat-checkbox>
        </div>

        <div class="row form-group" *ngIf="(saveForFuture === true) || (action === addRecipientFrom.ManageRecipient)">
          <mat-checkbox class="greengo circle-checkbox" formControlName="mandate" (change)="changeChecked($event)">Set as mandate</mat-checkbox>
        </div>
      </ng-container>

      <div class="row mt-2">
        <div class="col-6 pl-0 form-group">
          <button type="button" class="btn btn-lg btn-block btn-greengo-o" (click)="back()">Back</button>
        </div>
        <div class="col-6 pr-0 form-group">
          <button class="btn btn-lg btn-block" [ngClass]="{
              'btn-greengo': formStep2.valid && formStep3.valid && validationOk && (purposeOfPayments.length === 0 || (purposeOfPayments.length > 0 && purposeOfPaymentSelected)),
              'btn-inactive': !formStep2.valid || !formStep3.valid || !validationOk || (purposeOfPayments.length > 0 && !purposeOfPaymentSelected)
            }" (click)="nextStep3()" npFocusOutClicked>
            <ng-container *ngIf="action === addRecipientFrom.SendPayment && !remitterRequired">Send payment</ng-container>
            <ng-container *ngIf="action !== addRecipientFrom.SendPayment || remitterRequired">Next</ng-container>
          </button>
        </div>
      </div>
    </div>
  </form>

</div>
